(function () {
  if (window.__framePreviewInit) return;
  window.__framePreviewInit = true;

  const FRAME_OPTIONS = [
    { key: "negro", label: "Negro", color: "#302E2C", image: "https://cdn.shopify.com/s/files/1/0358/7814/2092/files/negro-frame-texture.jpg?v=1786125214", imageSlice: 50, swatchImage: "https://cdn.shopify.com/s/files/1/0358/7814/2092/files/negro-swatch.jpg?v=1786125214", shadowColor: "#1a1918", shadowAlpha: 0.5 },
    { key: "plateado", label: "Plateado", color: "#93938E", image: "https://cdn.shopify.com/s/files/1/0358/7814/2092/files/plateado-frame-texture.jpg?v=1786124121", imageSlice: 122, swatchImage: "https://cdn.shopify.com/s/files/1/0358/7814/2092/files/plateado-swatch.jpg?v=1786124121", shadowColor: "#4a4a48", shadowAlpha: 0.3 },
    { key: "blanco", label: "Blanco", color: "#F1F0EA", image: "https://cdn.shopify.com/s/files/1/0358/7814/2092/files/blanco-frame-texture.jpg?v=1786125213", imageSlice: 55, swatchImage: "https://cdn.shopify.com/s/files/1/0358/7814/2092/files/blanco-swatch.jpg?v=1786125213", shadowColor: "#cfcdc4", shadowAlpha: 0.22 },
    { key: "dorado", label: "Dorado", color: "#A38F5E", image: "https://cdn.shopify.com/s/files/1/0358/7814/2092/files/dorado-frame-texture.jpg?v=1786116583", imageSlice: 124, swatchImage: "https://cdn.shopify.com/s/files/1/0358/7814/2092/files/dorado-swatch.jpg?v=1786119710", shadowColor: "#5c4e32", shadowAlpha: 0.35 },
    { key: "natural", label: "Madera Natural", color: "#DFC79E", image: "https://cdn.shopify.com/s/files/1/0358/7814/2092/files/madera-frame-texture.jpg?v=1786125204", imageSlice: 38, swatchImage: "https://cdn.shopify.com/s/files/1/0358/7814/2092/files/madera-swatch.jpg?v=1786125203", shadowColor: "#B8A278", shadowAlpha: 0.28 }
  ];

  const PASPARTU_OPTIONS = [
    { key: "blanco", label: "Blanco", padding: "60px", background: "#FAFAF8" },
    { key: "negro", label: "Negro", padding: "60px", background: "#1C1C1C" },
    { key: "none", label: "Sin paspart\u00FA", padding: null, background: null }
  ];

  function borderImageFor(opt) {
    if (opt.image) return "url(" + opt.image + ") " + opt.imageSlice + " stretch";
    if (opt.gradient) return opt.gradient + " 1";
    return "none";
  }

  function swatchBg(opt) {
    if (opt.swatchImage) return "background-image:url(" + opt.swatchImage + ");background-size:cover;background-position:center;";
    if (opt.image) return "background-image:url(" + opt.image + ");background-size:cover;background-position:center;";
    return "background:" + (opt.gradient || opt.color) + ";";
  }

  function frameStyleFor(opt) {
    return {
      border: "18px solid " + opt.color,
      borderImage: borderImageFor(opt),
      boxShadow: "0 0 0 2px " + opt.shadowColor + ", 4px 4px 12px rgba(0,0,0," + opt.shadowAlpha + ")"
    };
  }

  const FRAME_ALIASES = {
    negro: ["negro", "black"],
    blanco: ["blanco", "white"],
    dorado: ["dorado", "gold", "oro"],
    plateado: ["plateado", "silver", "plata"],
    natural: ["natural", "madera"]
  };
  const FRAME_STYLES = {};
  FRAME_OPTIONS.forEach(function (opt) {
    const style = frameStyleFor(opt);
    (FRAME_ALIASES[opt.key] || [opt.key]).forEach(function (alias) {
      FRAME_STYLES[alias] = style;
    });
  });
  FRAME_STYLES["sin marco"] = null;
  FRAME_STYLES["sin enmarcado"] = null;
  FRAME_STYLES.none = null;

  const PASPARTU_STYLES = {
    blanco: { padding: "60px", background: "#FAFAF8" },
    blanca: { padding: "60px", background: "#FAFAF8" },
    white: { padding: "60px", background: "#FAFAF8" },
    negro: { padding: "60px", background: "#1C1C1C" },
    negra: { padding: "60px", background: "#1C1C1C" },
    black: { padding: "60px", background: "#1C1C1C" },
    sin: null,
    "sin paspart\u00FA": null,
    "sin paspartu": null,
    none: null
  };

  let currentFrameStyle = null, currentFrameLabel = null, currentPaspartuStyle = null, currentPaspartuLabel = null;

  function getProductForm() {
    return document.querySelector('.product-single__form, form[action*="/cart/add"]');
  }

  function setLineItemProperty(name, value) {
    const form = getProductForm();
    if (!form) return;
    let input = form.querySelector('input[data-fpp-prop="' + name + '"]');
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = "properties[" + name + "]";
      input.setAttribute("data-fpp-prop", name);
      form.appendChild(input);
    }
    input.value = value;
  }

  function removeLineItemProperty(name) {
    const form = getProductForm();
    if (!form) return;
    const input = form.querySelector('input[data-fpp-prop="' + name + '"]');
    if (input) input.remove();
  }

  function syncLineItemProperties() {
    if (currentFrameLabel) setLineItemProperty("Marco", currentFrameLabel);
    else removeLineItemProperty("Marco");
    if (currentPaspartuLabel) setLineItemProperty("Paspart\u00DA", currentPaspartuLabel);
    else removeLineItemProperty("Paspart\u00DA");
  }

  function matchStyle(value, map) {
    const normalized = value.toLowerCase().trim();
    if (Object.prototype.hasOwnProperty.call(map, normalized)) return map[normalized];
    for (const key of Object.keys(map)) {
      if (key.length > 2 && (normalized.includes(key) || key.includes(normalized))) return map[key];
    }
  }

  function isFrameOption(name) {
    const n = name.toLowerCase();
    return n.includes("marco") || n.includes("enmarcado") || n.includes("frame") || n.includes("framing") || n.includes("estilo");
  }
  function isGenericFrameValue(value) {
    const v = value.toLowerCase().trim();
    return v.includes("con marco") || v.includes("con enmarcado") || v.includes("with frame") || v.includes("a elecci") || v.includes("a eleccion");
  }
  function isNoFrameValue(value) {
    const v = value.toLowerCase().trim();
    return v.includes("sin marco") || v.includes("sin enmarcado") || v === "none" || v === "no frame";
  }

  function getFrameTargets() {
    const main = document.querySelector("[data-product-image-main]");
    return main ? [main] : [];
  }

  function syncOverrideStyles(active) {
    let el = document.getElementById("frame-preview-overrides");
    if (!el) {
      el = document.createElement("style");
      el.id = "frame-preview-overrides";
      document.head.appendChild(el);
    }
    el.textContent = active
      ? "[data-product-image-main] { box-sizing: border-box !important; } [data-product-image-main] .image-wrap { border-radius: 0 !important; }"
      : "";
  }

  function render() {
    if (window.__cfpIsDuo) return;
    const hasAny = currentFrameStyle || currentPaspartuStyle;
    syncOverrideStyles(hasAny);
    getFrameTargets().forEach(function (el) {
      el.style.transition = hasAny ? "border 0.3s ease, box-shadow 0.3s ease, padding 0.3s ease" : "";
      if (currentFrameStyle) {
        el.style.border = currentFrameStyle.border;
        el.style.borderImage = currentFrameStyle.borderImage;
        el.style.boxShadow = currentFrameStyle.boxShadow;
      } else {
        el.style.border = "";
        el.style.borderImage = "";
        el.style.boxShadow = "";
      }
      el.style.padding = currentPaspartuStyle ? currentPaspartuStyle.padding : (hasAny ? "0" : "");
      el.style.background = currentPaspartuStyle ? currentPaspartuStyle.background : "";
    });
  }

  function applyFrame(style, label) {
    currentFrameStyle = style;
    currentFrameLabel = label || null;
    render();
    syncLineItemProperties();
  }
  function applyPaspartu(style, label) {
    currentPaspartuStyle = style;
    currentPaspartuLabel = label || null;
    render();
    syncLineItemProperties();
  }

  function updateSizeNote(paspartuKey) {
    const div = document.getElementById("frame-preview-picker");
    if (!div) return;
    const conLine = div.querySelector('[data-note="con"]');
    const sinLine = div.querySelector('[data-note="sin"]');
    const hasPaspartu = paspartuKey !== "none";
    if (conLine) conLine.classList.toggle("fpp-note-active", hasPaspartu);
    if (sinLine) sinLine.classList.toggle("fpp-note-active", !hasPaspartu);
  }

  function injectPickerStyles() {
    if (document.getElementById("fpp-styles")) return;
    const s = document.createElement("style");
    s.id = "fpp-styles";
    s.textContent = "#frame-preview-picker{margin:10px 0 6px;padding:14px 16px 10px;background:#f8f7f5;border:1px solid rgba(0,0,0,0.09);border-radius:4px;}.fpp-group{margin-bottom:14px;}.fpp-group:last-child{margin-bottom:0;}.fpp-label{font-size:1.15rem;font-weight:500;letter-spacing:0.08em;text-transform:uppercase;margin-bottom:9px;display:flex;align-items:baseline;gap:6px;color:inherit;}.fpp-selected-name{font-weight:400;text-transform:none;opacity:0.55;font-size:1.05rem;}.fpp-swatches{display:flex;gap:8px;flex-wrap:wrap;align-items:flex-start;}.fpp-swatch{display:flex;flex-direction:column;align-items:center;gap:4px;cursor:pointer;padding:3px;border:2px solid transparent;background:none;border-radius:5px;transition:border-color 0.15s;}.fpp-swatch:hover{border-color:rgba(0,0,0,0.22);}.fpp-swatch.fpp-active{border-color:#1a1a1a;}.fpp-dot{width:30px;height:30px;border-radius:50%;border:1px solid rgba(0,0,0,0.13);display:flex;align-items:center;justify-content:center;font-size:13px;color:#aaa;box-sizing:border-box;flex-shrink:0;}.fpp-lbl{font-size:9.5px;text-transform:uppercase;letter-spacing:0.04em;color:#666;text-align:center;white-space:nowrap;max-width:52px;line-height:1.2;}.fpp-note{margin-top:12px;padding-top:11px;border-top:1px solid rgba(0,0,0,0.08);}.fpp-note-line{margin:0 0 4px;font-size:0.76rem;line-height:1.42;color:#9a9a9a;transition:color 0.15s;}.fpp-note-line strong{font-weight:600;}.fpp-note-line.fpp-note-active{color:#4a4a4a;}.fpp-note-sub{margin:6px 0 0;font-size:0.7rem;line-height:1.4;color:#a3a3a3;font-style:italic;}.fpp-note-glass{margin:6px 0 0;font-size:0.76rem;line-height:1.4;color:#000;}";
    document.head.appendChild(s);
  }

  function findAnchor() {
    const frameInput = Array.from(document.querySelectorAll("input[data-variant-input], select[data-variant-input]")).find(function (el) {
      return isFrameOption(el.name);
    });
    if (frameInput) {
      const block = frameInput.closest(".product-block") || frameInput.closest(".variant-wrapper");
      if (block) return block;
    }
    return (
      document.querySelector(".product__price-savings") ||
      document.querySelector(".product__price.on-sale") ||
      document.querySelector(".product__price") ||
      document.querySelector("[data-product-price-wrap]") ||
      document.querySelector(".product-single__prices") ||
      getProductForm()
    );
  }

  function showPicker() {
    if (document.getElementById("frame-preview-picker")) return;
    injectPickerStyles();
    const anchor = findAnchor();
    if (!anchor) return;

var techMarker = document.querySelector(".fpp-technique-marker");
var technique = techMarker ? techMarker.getAttribute("data-technique") : "";
var CANVAS_TECHNIQUES = ["Acrílico", "Óleo", "Técnica mixta"];
var isCanvasTechnique = CANVAS_TECHNIQUES.indexOf(technique) !== -1;
var glassNote = isCanvasTechnique ? '<p class="fpp-note-glass"><strong>El enmarcado de obras en tela no incluye vidrio (no lo necesitan para su conservación).</strong></p>' : "";
    const frameBtns = FRAME_OPTIONS.map(function (opt, i) {
      return '<button type="button" class="fpp-swatch' + (i === 0 ? " fpp-active" : "") + '" data-fpp-frame="' + opt.key + '" title="' + opt.label + '"><span class="fpp-dot" style="' + swatchBg(opt) + '"></span><span class="fpp-lbl">' + opt.label + "</span></button>";
    }).join("");

    const pBtns = PASPARTU_OPTIONS.map(function (opt, i) {
      const isNone = opt.key === "none";
      const dotStyle = opt.background ? "background:" + opt.background + ";" : "background:#fff;";
      const inner = isNone ? "\u2715" : "";
      return '<button type="button" class="fpp-swatch' + (i === 0 ? " fpp-active" : "") + '" data-fpp-paspartu="' + opt.key + '" title="' + opt.label + '"><span class="fpp-dot" style="' + dotStyle + '">' + inner + '</span><span class="fpp-lbl">' + opt.label + "</span></button>";
    }).join("");

    const div = document.createElement("div");
    div.id = "frame-preview-picker";
    div.innerHTML =
      '<div class="fpp-group"><div class="fpp-label">Marco: <span class="fpp-selected-name" id="fpp-frame-name">Negro</span></div><div class="fpp-swatches">' + frameBtns + "</div></div>" +
      '<div class="fpp-group"><div class="fpp-label">Paspart\u00DA: <span class="fpp-selected-name" id="fpp-paspartu-name">Blanco</span></div><div class="fpp-swatches">' + pBtns + "</div></div>" +
      '<div class="fpp-note">' +
        '<p class="fpp-note-line" data-note="con"><strong>Con marco y paspart\u00FA:</strong> la obra aumenta aprox. 17\u201320 cm en total.</p>' +
        '<p class="fpp-note-line" data-note="sin"><strong>Solo marco:</strong> la obra aumenta aprox. 3 cm en total.</p>' +
        '<p class="fpp-note-sub">Marcos de aprox. 2 cm de ancho. Medidas aproximadas: si necesitas una medida final espec\u00EDfica, escr\u00EDbenos despu\u00E9s de tu compra para coordinarla.</p>' +
        glassNote +
      "</div>";
    anchor.insertAdjacentElement("afterend", div);

    div.querySelectorAll("[data-fpp-frame]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        const opt = FRAME_OPTIONS.find(function (o) { return o.key === btn.dataset.fppFrame; });
        if (!opt) return;
        applyFrame(frameStyleFor(opt), opt.label);
        div.querySelectorAll("[data-fpp-frame]").forEach(function (b) { b.classList.remove("fpp-active"); });
        btn.classList.add("fpp-active");
        const nm = document.getElementById("fpp-frame-name");
        if (nm) nm.textContent = opt.label;
      });
    });

    div.querySelectorAll("[data-fpp-paspartu]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        const opt = PASPARTU_OPTIONS.find(function (o) { return o.key === btn.dataset.fppPaspartu; });
        if (!opt) return;
        applyPaspartu(opt.padding ? { padding: opt.padding, background: opt.background } : null, opt.key !== "none" ? opt.label : null);
        div.querySelectorAll("[data-fpp-paspartu]").forEach(function (b) { b.classList.remove("fpp-active"); });
        btn.classList.add("fpp-active");
        const nm = document.getElementById("fpp-paspartu-name");
        if (nm) nm.textContent = opt.label;
        updateSizeNote(opt.key);
      });
    });

    const def = FRAME_OPTIONS[0];
    applyFrame(frameStyleFor(def), def.label);
    const defP = PASPARTU_OPTIONS[0];
    applyPaspartu({ padding: defP.padding, background: defP.background }, defP.label);
    updateSizeNote(defP.key);
  }

  function hidePicker() {
    const el = document.getElementById("frame-preview-picker");
    if (el) el.remove();
    applyFrame(null);
    applyPaspartu(null);
  }

  function handleOptionChange(optionName, value) {
    if (!optionName || !value) return;
    if (!isFrameOption(optionName)) return;
    if (isNoFrameValue(value)) { hidePicker(); return; }
    if (isGenericFrameValue(value)) { showPicker(); return; }
  }

  function detectInitialState() {
    document.querySelectorAll("input[data-variant-input]").forEach(function (input) {
      const checked = input.type === "radio" || input.type === "checkbox" ? input.checked : true;
      if (checked && input.value) handleOptionChange(input.name, input.value);
    });
    const select = document.querySelector("select[data-variant-input]");
    if (select && select.value) {
      const opt = select.options[select.selectedIndex];
      handleOptionChange(select.name, opt ? opt.text : select.value);
    }
  }

  function initFramePreview() {
    document.addEventListener("change", function (e) {
      const input = e.target;
      if (!input || !input.hasAttribute || !input.hasAttribute("data-variant-input")) return;
      const value = (input.tagName === "SELECT" && (input.options[input.selectedIndex] || {}).text) || input.value;
      handleOptionChange(input.name, value);
    });
    document.addEventListener("variant:change", function (e) {
      const variant = e.detail && e.detail.variant;
      if (!variant) return;
      [variant.option1, variant.option2, variant.option3].forEach(function (value) {
        if (!value) return;
        if (isNoFrameValue(value)) hidePicker();
        else if (isGenericFrameValue(value)) showPicker();
      });
    });
    detectInitialState();
    setTimeout(detectInitialState, 300);
  }

  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", initFramePreview) : initFramePreview();
})();
